import "../assets/css/ConfigPage.css";
import { useEffect, useState, useRef } from "react";

import { format, differenceInDays, addDays } from "date-fns";
import "../assets/css/ConfigPage.css";
import { Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { linkWhatsapp } from "../global/GlobalVariables";
import { logoutUser } from "../global/GlobalFunctions";

import { openPagePayment } from "./functions/Payment";
import ModalAlertLoading from "./ModalAlertLoading";

import { updatePassword,  updatePhone, deleteAccount} from "../api/user/userService";

import ModalConfirm from "./ModalConfirm";
import InputMask from "react-input-mask";
import { MessageAccountDeleted } from "./MessageAccountDeleted";
const ConfigPage = (props) => {
  const {
    statusMode,
    setStatusMode,
    setIsLoggedIn,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
    user,
    valueMin,
    valueMax,
    betHome,
    sports,
    timeEvent,
    itemsTrash,
    setItemsTrash,
    controllerLocalStorage,
    setValueMin,
    setValueMax,
    setBetHome,
    quantityBetHomeEnabled,
    setQuantityBetHomeEnabled,
    setSports,
    quantitySportsEnabled,
    setQuantitySportsEnabled,
    setTimeEvent,

    setPopupWindow,
    popupWindow,
    setPopupWindowBet,
    popuwindowsBet,
    setIdinitialization,
    setAmountinitialization,
    Idinitialization,
    setUserData,
  } = props;
  const navigate = useNavigate();

  const dataPagamento = new Date(user.data_pagamento);
  const [userDatas, setUsersData] = useState(user);

  
  const [newPassword, setNewPassword] = useState("");
  const [dataExpiracao, setDataExpiracao] = useState("");
  const [phone, setPhone] = useState("");
  
  const [activeTab, setActiveTab] = useState("status");
  
  const [diasRestantes, setdiasRestantes] = useState(0);
  const [isAccountDelete, setIsAccountDelete] = useState(false);
  const [messageModal, setMessageModal] = useState("");
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [iconToShow, setIconToShow] = useState("");

  const functionStorage = useRef(function () {});
  const [showModalConfirm, setShowModalConfirm] = useState(false);

  const handlePayment = async (planNames, price) => {
    let planName = String(planNames);

    const partes = planName.split(" ");

    const tipo = planNames.includes("Ao Vivo")
      ? "Ao Vivo"
      : planNames.includes("-Pro")
      ? "Pre evento -Pro"
      : partes[0].trim();

    const periodicidade = planName.includes("Trimestral")
      ? "Trimestral"
      : planName.includes("Anual")
      ? "Anual"
      : "Mensal";

    let pricecustom = 0;

    if (tipo == "Light") {
      pricecustom = periodicidade.includes("Anual")
        ? 999
        : periodicidade.includes("Trimestral")
        ? 269
        : 99.9;
    } else if (tipo.includes("Ao Vivo")) {
      pricecustom = periodicidade.includes("Anual")
        ? 2987
        : periodicidade.includes("Trimestral")
        ? 809
        : 299;
    } else if (tipo.includes("Profissional")) {
      pricecustom = periodicidade.includes("Anual")
        ? 4979
        : periodicidade.includes("Trimestral")
        ? 1349
        : 499.0;
    } else if (tipo.includes("Pro")) {
      pricecustom = periodicidade.includes("Anual")
        ? 2987
        : periodicidade.includes("Trimestral")
        ? 809
        : 299;
    }

    let namePlan = encodeURIComponent(
      `Arbritagem Bet ${tipo} ${periodicidade} `.trim().toLocaleLowerCase()
    );

    await openPagePayment(namePlan, navigate);
  };


  const handleUpdatePassword = () => {
    setIconToShow("");
    setMessageModal("Aguarde enquanto atualizamos a sua senha.");
    setShowModalMessage(true);
    updatePassword(newPassword).then((data) => {
      let statusHttp = data["statusHttp"];

      if (statusHttp !== 200) {
        setIconToShow("error");
        setMessageModal(data["message"]);
      } else if (statusHttp === 200) {
        setIconToShow("success");
        setMessageModal(data["message"]);
        setNewPassword("");
      }
    });
  };

  const handleUpdatePhone = () => {
    setIconToShow("");
    setMessageModal("Aguarde enquanto atualizamos o seu telefone.");
    setShowModalMessage(true);
    updatePhone(phone).then((data) => {
      let statusHttp = data["statusHttp"];

      if (statusHttp !== 200) {
        setIconToShow("error");
        setMessageModal(data["message"]);
      } else if (statusHttp === 200) {
        setIconToShow("success");
        setMessageModal(data["message"]);
        setPhone("");
      }
    });
  };

  const handleDeleteAccount = () => {
    functionStorage.current = function (canExecuteAction) {
      if (canExecuteAction === true) {
        setMessageModal("Aguarde enquanto excluimos a sua conta.");
        setShowModalMessage(true);
        deleteAccount().then((data) => {
          let statusHttp = data["statusHttp"];

          if (statusHttp !== 200) {
            setIconToShow("error");
            setMessageModal(data["message"]);
          } else if (statusHttp === 200) {
            setShowModalMessage(false);

            setMessageModal("");

            setIsAccountDelete(true);
          }
        });
      }
    };
    setMessageModal("Tem certeza que deseja excluir sua conta?");
    setShowModalConfirm(true);
  };

  const handleVoltarClick = () => {
    logoutUser().then( ()=>{
      setIsLoggedIn(false);
    window.location.href = "/";
    });
    
  };//

  const handleSetActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const extrairDuracaoDoPlano = (descricaoPlano) => {
    if (descricaoPlano.toLowerCase().includes("mensal")) {
      return 30;
    } else if (descricaoPlano.toLowerCase().includes("trimestral")) {
      return 90;
    } else if (descricaoPlano.toLowerCase().includes("anual")) {
      return 365;
    } else {
      return 0;
    }
  };

  const duracaoPlano = extrairDuracaoDoPlano(userDatas.tipo_de_plano);
  

  useEffect(() => {
    if (userDatas.data_expiracao != null) {
      const dataExpiracao = addDays(
        new Date(( userDatas.data_expiracao + "T00:00:00")),
        0
      );
      setDataExpiracao(dataExpiracao);
      const dataAtual = new Date();

      const diasRestantes = differenceInDays(dataExpiracao, dataAtual) + 1;
      setdiasRestantes(diasRestantes);

      if (diasRestantes <= 0 || userDatas.status_da_conta == "Inativo") {
        setIsLoggedIn(false);
        setUsersData(null);
        handleVoltarClick();
        return;
      }
    } else if (userDatas.data_expiracao == null) {
      const dataExpiracao = addDays(dataPagamento, duracaoPlano);
      setDataExpiracao(dataExpiracao);
      const dataAtual = new Date();

      const diasRestantes = differenceInDays(dataExpiracao, dataAtual) + 1;
      setdiasRestantes(diasRestantes);

      if (diasRestantes <= 0 || userDatas.status_da_conta == "Inativo") {
        setIsLoggedIn(false);
        setUsersData(null);
        handleVoltarClick();
        return;
      }
    }
  }, [diasRestantes]);

  return isAccountDelete === true ? (
    <MessageAccountDeleted />
  ) : (
    <>
      <ModalAlertLoading
        messageModal={messageModal}
        show={showModalMessage}
        setShow={setShowModalMessage}
        iconToShow={iconToShow}
      />
      <ModalConfirm
        messageModal={messageModal}
        show={showModalConfirm}
        setShow={setShowModalConfirm}
        functionStorage={functionStorage}
      />
      <div className="config-wrapper">
        <div className="sidebar">
          <div className="titlesidebar">PAINEL DE USUARIO</div>
          <div className="bodysidebar-config">
            <div
              className="sidebar-item"
              onClick={() => handleSetActiveTab("status")}
            >
              Status do Plano
            </div>
            <div
              className="sidebar-item"
              onClick={() => handleSetActiveTab("dados")}
            >
              Dados do usuário
            </div>
            <div
              className="sidebar-item"
              onClick={() => handleSetActiveTab("downloads")}
            >
              Downloads
            </div>
            <div
              className="sidebar-item"
              onClick={() => handleSetActiveTab("suporte")}
            >
              Suporte
            </div>
            <div className="sidebar-item sair" onClick={handleVoltarClick}>
              Sair <FontAwesomeIcon icon={faSignOutAlt} />
            </div>
          </div>
        </div>
        <div className="main-content">
          {activeTab === "status" && (
            <div className="status-card body-carduser">
              <div className="status-header">
                <h3 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Status do Plano
                </h3>
              </div>
              <div className="status-info">
                <div className="dadosconta">
                  <div className="statusconta">
                    Plano {userDatas.status_da_conta} [
                    {userDatas.status_da_conta == "Ativo" ? (
                      <div className="spuuner-div spinner-grow text-success"></div>
                    ) : userDatas.status_da_conta == "FourHours" ? (
                      <div className="spuuner-div spinner-grow text-success"></div>
                    ) : (
                      <div className="spuuner-div spinner-grow text-danger"></div>
                    )}
                    ]
                  </div>
                  <div className="planoconta">
                    <p className={` ${statusMode ? "text-light" : "textDark"}`}>
                      Plano Atual:{" "}
                      <b>
                        {userDatas.tipo_de_plano.replace("Arbritagem Bet ", "")}
                      </b>
                    </p>
                  </div>
                  <div className="diasconta">
                    <p className={` ${statusMode ? "text-light" : "textDark"}`}>
                      Dias Restantes: {diasRestantes > 0 ? diasRestantes : 0}{" "}
                      {/* Evita números negativos */}
                    </p>
                    <p className={` ${statusMode ? "text-light" : "textDark"}`}>
                      Data Expiração:{" "}
                      {dataExpiracao
                        ? format(dataExpiracao, "dd/MM/yyyy")
                        : "N/A"}
                    </p>
                    <p className={` ${statusMode ? "text-light" : "textDark"}`}>
                      Data Pagamento:{" "}
                      {dataPagamento
                        ? format(dataPagamento, "dd/MM/yyyy")
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="status-actions">
                <button
                  className="btn-renovar"
                  onClick={() => {
                    let name_plan = userDatas.tipo_de_plano
                      .replace("Arbritagem Bet ", "")
                      .trim();

                    if (name_plan.toLowerCase().trim() === "teste") {
                      name_plan = "Arbritagem Bet Light Mensal".replace(
                        "Arbritagem Bet ",
                        ""
                      );
                    }

                    handlePayment(name_plan);
                  }}
                >
                  Renovar plano
                </button>

                <NavLink to="/renovacao">
                  <button className="btn-mudar">Mudar de plano</button>
                </NavLink>
              </div>
            </div>
          )}
          {activeTab === "dados" && (
            <div className="user-data-card body-carduser">
              <div className="status-header">
                <h3 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Dados do Usuário
                </h3>
              </div>

              <Form className="forms-configpage">
                <Form.Group>
                  <Form.Label
                    className={` ${statusMode ? "text-light" : "textDark"}`}
                  >
                    Nova Senha
                  </Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Nova senha"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Form.Group>
                <Button
                  disabled={newPassword.length <= 0 ? true : false}
                  variant="primary"
                  onClick={handleUpdatePassword}
                >
                  Atualizar Senha
                </Button>
              </Form>
              <hr />
              <Form className="forms-configpage">
                <Form.Group>
                  <Form.Label
                    className={` ${statusMode ? "text-light" : "textDark"}`}
                  >
                    Novo Telefone
                  </Form.Label>

                  <InputMask
                    className="form-control"
                    mask="(99) 9 9999-9999"
                    type="tel"
                    name="phone"
                    placeholder="Novo telefone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button
                  className={` ${statusMode ? "text-light" : "textDark"}`}
                  variant="primary"
                  disabled={phone.length <= 0 ? true : false}
                  onClick={handleUpdatePhone}
                >
                  Atualizar Telefone
                </Button>
              </Form>
              <hr />
              <div className="center-btn" style={{ textAlign: "center" }}>
                <Button
                  className={` ${statusMode ? "text-light" : "textDark"}`}
                  variant="danger"
                  onClick={handleDeleteAccount}
                >
                  Excluir Conta
                </Button>
              </div>
            </div>
          )}
          {activeTab === "downloads" && (
            <div className="downloads-card body-carduser">
              <div className="status-header">
                <h3 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Área de Downloads
                </h3>
              </div>

              {/* Conteúdo dos Downloads */}
            </div>
          )}
          {activeTab === "suporte" && (
            <div className="support-card body-carduser">
              <div className="status-header">
                <h3>Suporte</h3>
              </div>

              <p>Para obter suporte, entre em contato pelo WhatsApp.</p>
              <Button
                className={` ${statusMode ? "text-light" : "textDark"}`}
                variant="primary"
                href={linkWhatsapp}
              >
                Contatar Suporte via Telegram
              </Button>
            </div>
          )}
          {activeTab === "sair" && (
            <div className="body-carduser">
              <div className="status-header">
                <h1 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Desconectar
                </h1>
              </div>

              <hr />

              <li className="nav-link">
                <span className="navlink">
                  <a className="linknavbar" onClick={handleVoltarClick}>
                    <b className={` ${statusMode ? "text-light" : "textDark"}`}>
                      SAIR <FontAwesomeIcon icon={faSignOutAlt} />
                    </b>
                  </a>
                </span>
              </li>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ConfigPage;
